import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays product SKU information.
 * This component listens for variant update events and updates the SKU display accordingly.
 */
class ProductSku extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  /**
   * Updates the SKU information.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSku = (event) => {
    // Handle product changes for combined listings
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Find the new SKU element in the updated HTML
    const newSkuElement = event.detail.data.html.querySelector('product-sku [ref="skuContainer"]');
    const currentSkuElement = this.querySelector('[ref="skuContainer"]');

    if (!newSkuElement || !currentSkuElement) return;

    // Only update if the content has changed
    if (currentSkuElement.innerHTML !== newSkuElement.innerHTML) {
      currentSkuElement.replaceWith(newSkuElement);
    }
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}
